<template>
    <div class="upload-single-file-input">
        <!-- 按鈕 ＆ 列表 -->
        <div>
            <el-button @click="onUpload" v-if="inputVal == null">上傳</el-button>
            <ahUploader ref="ahUploader" @change="onChangeAttachment" />
            <div class="file-list" v-if="inputVal">
                <ahFileItem :url="inputVal" :editable="true" @edit="onEdit" @delete="handleFileDeleteBtnClick"></ahFileItem>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import ahFileItem from '@/components/ui/ahFileItem.vue';
import ahUploader from '@/components/ui/Uploader/ahUploader.vue';

export default {
    name: 'upload-single-file-input',
    components: { ahFileItem, ahUploader },
    props: {
        value: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            cropImg: '',
        };
    },
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },

    methods: {
        onUpload() {
            this.openFileSelector();
        },
        onEdit() {
            this.openFileSelector();
        },

        openFileSelector() {
            this.$refs.ahUploader.onUploadFile();
        },

        onChangeAttachment(receiptData) {
            // apply data
            if (receiptData) {
                _.forEach(receiptData, (value, key) => {
                    if (key === 'filE_ATT') this.inputVal = value;
                });
            }
        },

        handleFileDeleteBtnClick() {
            this.inputVal = null;
        },
    },
};
</script>
